// extracted by mini-css-extract-plugin
export var orderDetails = "_uh-2";
export var orderImage = "_uh-1";
export var orderMeta = "_uh-3";
export var orderSummary = "_uh-0";
export var rightArrow = "_uh-4";